import { Box } from '@withjoy/joykit';
import React from 'react';
import { useLineageTitles } from '../../hooks/useLineageTitles';
import { MarketingText } from '@shared/utils/fonts/components';
import { useCatalogContext } from '../../state/Catalog';
import { useTranslation } from '@shared/core';

export const SelectedCategoryText: React.FC<{ disableMarginBottom?: boolean; isDepartment?: boolean }> = ({ disableMarginBottom = false, isDepartment = true }) => {
  const lineageTitles = useLineageTitles();
  const { selectedCategory } = useCatalogContext();
  const { t } = useTranslation('catalogRegistry');
  const { popularCategory } = t('productGrid');
  if (!lineageTitles.length) {
    return null;
  }
  return (
    <StyledCategoryTitle marginBottom={disableMarginBottom ? undefined : 17}>
      {selectedCategory?.isPopularStoreCategory && !isDepartment
        ? popularCategory({ title: lineageTitles[lineageTitles.length - 1]?.category.title })
        : lineageTitles[lineageTitles.length - 1]?.category.title}
    </StyledCategoryTitle>
  );
};

type StyledCategoryTitleProps = React.PropsWithChildren<{
  marginBottom?: string | number;
}>;

export const StyledCategoryTitle = React.forwardRef<HTMLDivElement, StyledCategoryTitleProps>(({ marginBottom = 17, children }, ref) => (
  <Box
    marginBottom={marginBottom}
    ref={ref}
  >
    <MarketingText
      as="h1"
      typeVariant={['HedMobile32', null, 'Hed56']}
      fontFamily="'Austin News Headline'"
      textAlign={'center'}
    >
      {children}
    </MarketingText>
  </Box>
));
